import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress,
  Pagination,
  Box,
  Typography,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
} from "@mui/icons-material";
import { apiUrl } from "../../comps/apiUrl";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

class Contracts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      add: false,
      dados: { title: "", content: "" }, // Inicializado para evitar erros de componente não-controlado
      currentPage: 1,
      totalPages: 0,
      itemsPerPage: 15,
      loader: true,
      edit: {},
      trash: {},
    };
  }

  componentDidMount() {
    document.title = "Contratos";
    this.fetchData(this.state.currentPage);
  }

  formatarMoeda = (valor) => {
    if (!valor) return "R$ 0,00";
    const apenasNumeros = String(valor).replace(/\D/g, "");
    return (Number(apenasNumeros) / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  fetchData(page) {
    this.setState({ loader: true });
    fetch(`${apiUrl}/contracts?page=${page}&limit=${this.state.itemsPerPage}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status === 510) {
          localStorage.clear();
          window.location.href = "/";
          return;
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          const totalItems = data.totalItems || 0;
          const totalPages = Math.ceil(totalItems / this.state.itemsPerPage) || 1;

          this.setState({
            items: data.items || [],
            currentPage: page,
            totalPages: totalPages,
            loader: false,
          });
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        toast.error("Erro ao carregar dados do servidor.");
      });
  }

  handlePageChange = (event, value) => {
    this.fetchData(value);
  };

  handleSaveCreate = () => {
    const { dados } = this.state;
    if (!dados.title.trim()) {
      toast.warning("O título é obrigatório!");
      return;
    }

    fetch(`${apiUrl}/contract/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dados),
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            this.setState((prevState) => ({
              items: [
                {
                  token: data.token,
                  title: dados.title,
                  created_at: data.created_at || new Date().toLocaleDateString(),
                },
                ...prevState.items,
              ],
              add: false,
              dados: { title: "", content: "" }, // Limpa formulário
            }));
            toast.success("Contrato criado com sucesso!");
          });
        }
      })
      .catch(() => {
        toast.error("Falha na comunicação com o servidor!");
      });
  };

  handleSaveEdit = () => {
    const { edit } = this.state;
    if (!edit.title.trim()) {
      toast.warning("O título é obrigatório!");
      return;
    }

    fetch(`${apiUrl}/contract/${edit.token}/update`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        title: edit.title,
        content: edit.content,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState((prevState) => ({
            items: prevState.items.map((item) =>
              item.token === edit.token
                ? { ...item, title: edit.title, content: edit.content }
                : item
            ),
            edit: {},
          }));
          toast.success("Contrato editado com sucesso!");
        }
      })
      .catch(() => {
        toast.error("Falha na comunicação com o servidor!");
      });
  };

  handleDelete = () => {
    const token = this.state.trash.token;
    fetch(`${apiUrl}/deletar-contrato`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token }),
    })
      .then((response) => {
        if (response.ok) {
          this.setState((prevState) => ({
            items: prevState.items.filter((item) => item.token !== token),
            trash: {},
          }));
          toast.success("Contrato excluído com sucesso!");
        }
      })
      .catch(() => {
        toast.error("Erro ao deletar o contrato.");
      });
  };

  render() {
    if (this.state.loader) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
          <CircularProgress size={60} />
        </Box>
      );
    }

    return (
      <Box p={3}>
        <Card variant="outlined">
          <CardHeader
            title={<Typography variant="h5" component="h1" fontWeight="bold">Contratos</Typography>}
            action={
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => this.setState({ add: true })}
              >
                Criar Contrato
              </Button>
            }
          />
          <CardContent>
            {this.state.items.length > 0 ? (
              <TableContainer component={Paper} variant="outlined">
                <Table>
                  <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }} align="center">Título</TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="center">Data</TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="center" width="150">Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.items.map((item) => (
                      <TableRow key={item.token || item.title} hover>
                        <TableCell align="center">{item.title}</TableCell>
                        <TableCell align="center">{new Date(item.created_at).toLocaleDateString({ day: "2-digit", month: "2-digit", year: "numeric" })}</TableCell>
                        <TableCell align="center">
                          <IconButton
                            color="primary"
                            onClick={() => this.setState({ edit: { ...item } })}
                            size="small"
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            color="error"
                            onClick={() => this.setState({ trash: item })}
                            size="small"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Box py={4} textAlign="center">
                <Typography color="textSecondary">Não há resultados encontrados.</Typography>
              </Box>
            )}

            {this.state.totalPages > 1 && (
              <Box display="flex" justifyContent="center" mt={3}>
                <Pagination
                  count={this.state.totalPages}
                  page={this.state.currentPage}
                  onChange={this.handlePageChange}
                  color="primary"
                  shape="rounded"
                />
              </Box>
            )}
          </CardContent>
        </Card>

        {/* DIALOG DE CRIAR */}
        <Dialog
          open={this.state.add}
          onClose={() => this.setState({ add: false, dados: { title: "", content: "" } })}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>Criar Contrato</DialogTitle>
          <DialogContent dividers>
            <TextField
              autoFocus
              margin="dense"
              id="title"
              label="Título do Contrato"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.dados.title}
              onChange={(e) =>
                this.setState({ dados: { ...this.state.dados, title: e.target.value } })
              }
              sx={{ mb: 3 }}
            />
            <Box sx={{ minHeight: "200px", mb: 2 }}>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                Conteúdo do Contrato
              </Typography>
              <ReactQuill
                theme="snow"
                value={this.state.dados.content}
                onChange={(content) =>
                  this.setState({ dados: { ...this.state.dados, content } })
                }
                style={{ height: "150px" }}
              />
            </Box>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => this.setState({ add: false })} color="inherit">
              Cancelar
            </Button>
            <Button
              onClick={this.handleSaveCreate}
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
            >
              Salvar
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE EDITAR */}
        <Dialog
          open={Object.keys(this.state.edit).length > 0}
          onClose={() => this.setState({ edit: {} })}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>Editar Contrato</DialogTitle>
          <DialogContent dividers>
            <TextField
              autoFocus
              margin="dense"
              id="edit-title"
              label="Título do Contrato"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.edit.title || ""}
              onChange={(e) =>
                this.setState({ edit: { ...this.state.edit, title: e.target.value } })
              }
              sx={{ mb: 3 }}
            />
            <Box sx={{ minHeight: "200px", mb: 2 }}>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                Conteúdo do Contrato
              </Typography>
              <ReactQuill
                theme="snow"
                value={this.state.edit.content || ""}
                onChange={(content) => {
                  if (content === "<p><br></p>") return;
                  this.setState({ edit: { ...this.state.edit, content } });
                }}
                style={{ height: "150px" }}
              />
            </Box>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => this.setState({ edit: {} })} color="inherit">
              Cancelar
            </Button>
            <Button
              onClick={this.handleSaveEdit}
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
            >
              Salvar Alterações
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE CONFIRMAÇÃO DE EXCLUSÃO */}
        <Dialog
          open={Object.keys(this.state.trash).length > 0}
          onClose={() => this.setState({ trash: {} })}
        >
          <DialogTitle>Tem certeza de que deseja continuar?</DialogTitle>
          <DialogContent>
            <Typography>
              Se você confirmar a exclusão, não será possível recuperar os dados posteriormente.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => this.setState({ trash: {} })} color="inherit">
              Cancelar
            </Button>
            <Button
              onClick={this.handleDelete}
              variant="contained"
              color="error"
              startIcon={<DeleteIcon />}
            >
              Excluir
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

export default Contracts;